import { NativeDateAdapter } from '@angular/material/core';
import { Injectable, LOCALE_ID, inject } from '@angular/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  locale: string;

  constructor() {
    const locale = inject(LOCALE_ID);

    super(locale);

    this.locale = locale;
  }

  getFirstDayOfWeek(): number {
    return 1;
  }
}
